import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Boxes, ArrowRight, Package } from "lucide-react";
import api, { money } from "@/lib/api";
import { NewLotsButton } from "@/components/NewLotsButton";

export default function Lots() {
  const [lots, setLots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/lots").then((r) => setLots(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8">
      <div className="border-b-2 border-ink pb-4 mb-8">
        <div className="inline-block bg-ink text-paper font-mono text-[11px] uppercase tracking-[0.2em] px-3 py-1 mb-3">Shop By Lot</div>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tighter">AUCTION LOTS</h1>
            <p className="font-mono text-sm text-subtle mt-2 max-w-xl">Each lot is a full pallet we acquired at auction. Browse everything in a lot on one shareable page.</p>
          </div>
          <NewLotsButton />
        </div>
      </div>

      {loading ? (
        <div className="font-mono text-subtle">Loading…</div>
      ) : lots.length === 0 ? (
        <div className="border border-dashed border-subtle p-12 text-center font-mono text-sm text-subtle">No lots available yet.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {lots.map((lot) => (
            <Link
              key={lot.lot_name}
              to={`/lot/${encodeURIComponent(lot.lot_name)}`}
              data-testid={`lot-card-${lot.lot_name}`}
              className="group bg-paper border border-ink flex flex-col hover:shadow-hard transition-all duration-150"
            >
              <div className="relative aspect-[16/9] border-b border-ink bg-surface overflow-hidden">
                {lot.image ? <img src={lot.image} alt="" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-200" /> : <div className="h-full w-full flex items-center justify-center"><Boxes className="h-8 w-8 text-subtle" /></div>}
                {lot.avg_discount > 0 && <div className="absolute top-0 left-0 bg-discount text-ink font-heading font-black px-2 py-1 border-r border-b border-ink">~{lot.avg_discount}% OFF</div>}
              </div>
              <div className="p-4 flex flex-col flex-1">
                <div className="font-mono text-[10px] uppercase tracking-widest text-subtle">Lot</div>
                <div className="font-heading font-black text-xl tracking-tighter">{lot.lot_name}</div>
                <div className="flex gap-4 mt-3 font-mono text-xs text-subtle">
                  <span className="flex items-center gap-1"><Package className="h-3.5 w-3.5" /> {lot.product_count} SKUs</span>
                  <span className="flex items-center gap-1"><Boxes className="h-3.5 w-3.5" /> {lot.total_units} units</span>
                </div>
                <div className="mt-auto pt-4 flex items-center justify-between">
                  <span className="font-mono text-xs">Inventory <strong>{money(lot.total_value)}</strong></span>
                  <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
